<template>
	<v-row align="center" justify="center">
		<v-container fill-height>
			<v-row align="center" justify="center">
				<v-col cols="11" md="7" xl="5">
					<v-card elevation="12" class="pa-6 rounded-xl" color="#F5F5F5">
						<v-card-title class="mb-3 pt-2 pl-0 pr-0">
							<AppLogo />
						</v-card-title>
						<v-row align="center" v-if="loading" justify="center" class="pa-4">
							<v-progress-linear color="primary" indeterminate />
						</v-row>
						<v-card-text class="pa-0">
							<v-form>
								E-mail
								<v-text-field
									v-model="email"
									placeholder="E-mail"
									solo
									type="email"
									background-color="#F5F5F5"
									hide-details=""
									class="pb-2"
								/>
								Senha
								<v-text-field
									background-color="#F5F5F5"
									solo
									placeholder="Senha"
									hide-details
									v-model="senha"
									@click:append="visualizar = !visualizar"
									:type="visualizar ? 'text' : 'password'"
									@keypress.enter="login"
								>
									<template v-slot:append>
										<v-icon color="red" @click="visualizar = !visualizar">
											{{ visualizar ? 'mdi-eye' : 'mdi-eye-off' }}
										</v-icon>
									</template>
								</v-text-field>
							</v-form>
						</v-card-text>
						<v-card-actions class="pb-2 pt-4 pl-0 pr-0">
							<v-btn
								class="white--text"
								color="#CC2128"
								large
								elevation="9"
								width="100%"
								@click="login"
							>
								Entrar
							</v-btn>
						</v-card-actions>
						<v-row align="center">
							<v-col cols="5">
								<v-btn :disabled="loading" to="Signup" color="#CC2128" text  min-width="0" class="pa-0">Cadastre-se</v-btn>
							</v-col>
							<v-spacer class="d-none d-sm-flex"/>
							<v-col cols="7" class="text-right">
								<v-btn :disabled="loading" to="esqueceusenha" color="#CC2128" text min-width="0" class="pa-0 d-flex align-end flex-column">Esqueceu a senha?</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-row>
</template>
<script>
import AppLogo from '@/components/widgets/AppLogo'
import { mapActions } from 'vuex'

export default {
	components: { AppLogo },
	data: function () {
		return {
			email: '',
			senha: '',
			visualizar: false,
			loading: false,
		}
	},
	methods: {
		...mapActions(['showError']),
		async login() {
			try {
				this.loading = true
				if (!this.email || this.email === '') {
					throw 'Email inválido!'
				}
				if (!this.senha || this.senha === '') {
					throw 'Senha inválida!'
				}

				const response = await this.axios.post('/signin', { email: this.email, senha: this.senha })

				if (response.data.ativo === false) {
					throw new 'Usuário inativo!'()
				}

				this.$store.dispatch('login', response.data)
				this.$router.push('/fornecedores')
			} catch (error) {
				this.showError('Usuário e/ou senha inválidos!')
			} finally {
				this.loading = false
			}
		},
		checkUser() {
			if (this.$store.getters.userAtivo) return this.$router.push('/fornecedores')
		},
	},
	mounted() {
		this.checkUser()
	},
}
</script>